import { useState, useEffect, useMemo } from 'react';
import { ApolloProvider } from '@apollo/client/react';
import {ToastContainer} from "react-toastify"
import client from './config/apollo';
import Auth from './pages/Auth'; 
import {getToken, decodeToken}  from "./utils/token";
import AuthContext from './context/authContext';  
import Navigation from './routers/Navigation';

export default function App() {
  const [auth, setAuth] = useState(undefined);  

  useEffect(() => {
    const token = getToken();
    if(!token){
      setAuth(null);
    } else {
      setAuth(decodeToken(token));
    }
  }, []);

  const logout = () => {  
    console.log("Cerrando sesión");
  }

  const setUser = (user) => {
    setAuth(user);
  }

  const authData = useMemo(() => ({
    auth,
    logout,
    setUser,
  }), [auth]);

  if(auth === undefined) return null;
  
  return (
    <ApolloProvider client={client}>
        <AuthContext.Provider value={authData}>
          {!auth ? <Auth/> : <Navigation/>}
          <ToastContainer 
            position='top-right' 
            autoClose={5000} 
            hideProgressBar 
            newestOnTop 
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          </AuthContext.Provider>
      
    </ApolloProvider>
  )
}